export const PAGE_SIZE = 50;
export const SHOW_ALL_ITEMS_PARAM = 'all';
